import React from 'react';
import { useTranslation } from 'react-i18next';

const SkeletonBox = ({ className = '' }) => (
  <div className={`rounded animate-pulse ${className}`} style={{ backgroundColor: '#1f1f1f' }} />
);

const formatNum = (n) => {
  if (!n && n !== 0) return '0';
  return Math.round(n)?.toLocaleString('fr-FR')?.replace(/\u202f/g, '\u00a0');
};

const formatDate = (val) => {
  if (!val) return '—';
  // Handle both ISO datetime and plain date string (YYYY-MM-DD)
  const d = String(val)?.slice(0, 10);
  return d?.slice(8) + '/' + d?.slice(5, 7) + '/' + d?.slice(0, 4);
};

const SummaryCards = ({ summary, serverColor, loading }) => {
  const { t } = useTranslation();
  const cards = [
    {
      label: t('admin.performanceActuelle.summaryTotalDiamonds'),
      value: loading ? null : `💎 ${formatNum(summary?.total_diamonds)}`,
      sub: t('admin.performanceActuelle.summaryThisMonth'),
      color: serverColor,
    },
    {
      label: t('admin.performanceActuelle.summaryActiveCreators'),
      value: loading ? null : formatNum(summary?.active_creators),
      total: loading ? null : summary?.total_creators,
      goLiveRate: loading ? null : summary?.go_live_rate,
      sub: 'is_active = true',
      color: '#a78bfa',
    },
    {
      label: t('admin.performanceActuelle.summaryDaysElapsed'),
      value: loading ? null : formatNum(summary?.days_elapsed),
      sub: 'MAX(days_elapsed)',
      color: '#34d399',
    },
    {
      label: t('admin.performanceActuelle.summaryLastUpdate'),
      value: loading ? null : formatDate(summary?.last_update),
      sub: 'MAX date creator_daily',
      color: '#f59e0b',
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {cards?.map((card, i) => (
        <div
          key={i}
          className="rounded-xl p-3 border"
          style={{ backgroundColor: '#111111', borderColor: '#1f1f1f' }}
        >
          <p
            className="text-xs font-medium uppercase tracking-wider mb-1.5"
            style={{ color: 'rgba(255,255,255,0.35)', fontFamily: 'Inter, sans-serif' }}
          >
            {card?.label}
          </p>
          {loading ? (
            <>
              <SkeletonBox className="h-5 w-24 mb-1" />
              <SkeletonBox className="h-3 w-16" />
            </>
          ) : (
            <>
              <p
                className="text-lg font-bold mb-0.5"
                style={{ color: card?.color, fontFamily: 'Sora, sans-serif' }}
              >
                {card?.value}
                {card?.total != null && (
                  <span className="text-sm font-medium" style={{ color: 'rgba(255,255,255,0.4)' }}>/{formatNum(card.total)}</span>
                )}
              </p>
              {card?.goLiveRate != null ? (
                <p
                  className="text-xs font-bold"
                  style={{ color: card.goLiveRate >= 50 ? '#22c55e' : card.goLiveRate >= 30 ? '#f97316' : '#ef4444', fontFamily: 'Sora, sans-serif' }}
                >
                  {card.goLiveRate}% Go LIVE
                </p>
              ) : (
                <p
                  className="text-xs"
                  style={{ color: 'rgba(255,255,255,0.3)', fontFamily: 'Inter, sans-serif' }}
                >
                  {card?.sub}
                </p>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
